<template>
<v-card class="pa-4 box-shadow-custom">
    <v-row justify="space-between">
        <v-col cols="12" md="7" class="py-0">
            <v-toolbar-title class="font-weight-medium px-4 mt-4 headline primary--text">Logs</v-toolbar-title>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
            <v-dialog ref="dialog" v-model="date_range" :return-value.sync="date" persistent width="290px">
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        <v-combobox v-model="computedDateFormattedMomentjs" :value="date" outlined dense multiple label="Select Date" class="mt-4" append-icon="mdi-calendar"></v-combobox>
                    </span>
                </template>
                <v-date-picker v-model="date" color="primary" range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="date_range = false">Cancel</v-btn>
                    <v-btn text color="primary" :disabled="date.length != 2 || date[0] > date[1]" @click="onDate(date)">OK</v-btn>
                </v-date-picker>
            </v-dialog>
        </v-col>
    </v-row>
    <v-card flat v-if="desserts == ''">
        <v-img max-width="400" src="/images/error.png" lazy-src="/images/error.png" aspect-ratio="1.6" class="mx-auto">
            <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
            </template>
        </v-img>
        <p class='text-center headline font-weight-bold grey--text mt-3'>No Data</p>
    </v-card>
    <v-card flat v-else>
        <v-data-table :headers="headers" :loading="loading" loading-text="Loading... Please wait" :items="desserts" hide-default-footer class="elevation-0">
            <template v-slot:item.created="{ item }">
                <div>{{dateTime(item.created)}}</div>
            </template>
            <template v-slot:item.modified="{ item }">
                <div>{{dateTime(item.modified)}}</div>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn v-if="item.file != null" class="text-capitalize" color="success" small :href="item.file_url" @click="fireDownloadEvent" target="_block" download>
                    <v-icon small left>mdi-download</v-icon>
                    Download Logs
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</v-card>
</template>

<script>
import {
    mapActions
} from "vuex"
import moment from 'moment'
export default {
    data() {
        return {
            date: [],
            date_range: false,
            loading: false,
            title: '',
            headers: [{
                    text: 'Date',
                    align: 'start',
                    sortable: false,
                    value: 'created',
                },
                {
                    text: 'Message',
                    value: 'message'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: 'actions',
                    sortable: false
                },
            ],
            desserts: [],
        }
    },
    mounted() {
        this.initialize()
    },
    computed: {
        dateRangeText() {
            return this.date.join(' ~ ')
        },
        computedDateFormattedMomentjs() {
            return this.date.map(res => {
                return this.date ? moment(res).format('l') : ''
            })
        }
    },
    methods: {
        ...mapActions(['GetResponse', 'TrackEvents']),
        async initialize() {
            this.loading = true
            try {
                let url = this.date != '' ? `/internal/v2/autotest/logs/${this.$route.params.id}?page=1&limit=100&start=${this.date[0]}&end=${this.date[1]}` : `/internal/v2/autotest/logs/${this.$route.params.id}`;
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.title = data.data.test.name
                    this.desserts = data.data.logs
                    this.loading = false
                }
                this.loading = false
            } catch (err) {
                console.log(err)
                this.loading = false
            }
        },
        async onDate(date) {
            this.$refs.dialog.save(date)
            await this.initialize()
        },
        dateTime(date) {
            return moment(date).format('MMMM Do YYYY h:mm a');
        },
        fireDownloadEvent() {
            this.TrackEvents({ event_name: 'autotest', download_logs: true })
        }
    }
}
</script>
